export const SET_CONTACT = "SET_CONTACT";
export const GET_CONTACT = "GET_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";